import React from "react";
import Features from "./features";
import Footer from "./footer";
import Banner from "./banner";
import Navbar from "./navbar";
import GoogleDrive from "./googleDrive";
import About from "./about";
import styles from "./index.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

function Index() {
	return (
		<>
			<Navbar />
			<div className={cx("container")}>
				<div className={cx("body")}>
					<Banner />
					<Features />
					<GoogleDrive />
					<About />
				</div>
				<Footer />
			</div>
			<div className={cx("bg-footer")}>
				<img
					src="/imgs/mail/footer-bg.svg"
					alt=""
					className={cx("image-bg")}
				/>
			</div>
		</>
	);
}

export default Index;
